import { ErrorMessage, Field, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { MdOutlineChevronRight } from 'react-icons/md'
import { PiShareFat, PiShareFatFill } from 'react-icons/pi' // thicker share icon
import * as Yup from "yup";
import CreateCompanyFooter from '../components/createcompanyfooter/CreateCompanyFooter'
// import LinkNavbar from '../components/linksnavbar/LinkNavbar'
import { Link, useLocation } from 'react-router-dom'
import Progressbar from './Progressbar'
import { getApiBaseUrl } from "../apiBaseUrlFinder";
import { CiFilter } from 'react-icons/ci'
import AllCompanyReviews from './AllCompanyReviews'
import { toast } from 'react-toastify'

const CompanyReviews = () => {
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email format.").required("Email is required."),
  });

  const initialValues = { email: "" };

  const handleSubmit = (values) => {
    console.log("Form Data Submitted: ", values);
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Share UI state
  const [copied, setCopied] = useState(false);

  // Little white+green flag toast
  const showFlag = (message) =>
    toast(message, {
      position: "top-center",
      autoClose: 1800,
      hideProgressBar: true,
      closeButton: false,
      draggable: false,
      className: "flag-toast",
      bodyClassName: "flag-toast-body",
      icon: <span className="flag-dot" />,
    });

  useEffect(() => {
    const companyId = queryParams.get("id");
    const companyName = queryParams.get("name");

    if (companyId && companyName) {
      const fetchCompanyData = async () => {
        setLoading(true);
        try {
          const params = new URLSearchParams({
            company_id: companyId,
            company_name: companyName,
          });
          const response = await fetch(`${getApiBaseUrl()}/company_profile?${params.toString()}`);
          if (!response.ok) throw new Error("Failed to fetch data");
          const data = await response.json();
          setCompanyData(data);
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };

      fetchCompanyData();
    }
  }, [location.search]);

  // Share
  const handleCopy = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        setCopied(true);
        showFlag("Company link copied");
      })
      .catch(err => {
        console.error("Failed to copy:", err);
        showFlag("Failed to copy link");
      });

    setTimeout(() => setCopied(false), 5000);
  };

  // Sort click
  const handleSortClick = () => {
    showFlag("This feature is coming soon");
  };

  return (
    <div>
      {/* Optional: <LinkNavbar /> */}

      {/* Inline styles for icon motion + toast visuals (scoped to this page) */}
      <style>
        {`
          /* micro-interactions for icons */
          .icon-btn {
            transition: transform .15s ease, opacity .15s ease, filter .15s ease;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
          .icon-btn:hover { transform: translateY(-1px); }
          .icon-btn:active { transform: scale(.94); }

          /* white + green flag toast */
          .flag-toast {
            background:#fff !important;
            color:#111 !important;
            border-left:4px solid #16a34a !important;
            border-radius:10px !important;
            box-shadow:0 6px 18px rgba(0,0,0,.12) !important;
            padding:.75rem 1rem !important;
            min-width: 220px;
          }
          .flag-toast-body { font-weight:600; }
          .flag-dot {
            width:10px; height:10px; display:inline-block;
            border-radius:50%; background:#16a34a; margin-right:.5rem;
          }

          /* Rate button subtle motion (matches other pages) */
          .rate_company_profile_btn{
            transition: transform .15s ease, box-shadow .2s ease;
          }
          .rate_company_profile_btn:hover{
            transform: translateY(-1px);
          }
          .rate_company_profile_btn:active{
            transform: translateY(0) scale(.98);
          }
        `}
      </style>

      <div className='container'>
        <div className='row pt-lg-5 pt-md-4 pt-3'>
          <div className='col-lg-6 col-md-6 col-12'>
            {/* Hidden rating line kept as-is */}
            <p className='company_profile_rating_p pt-2 d-none'>
              {companyData?.company_profile?.all_review_count}{" "}
              <span style={{ textDecoration: "underline", cursor: "pointer" }}>ratings</span>
            </p>

            <div>
              <div className='d-flex align-items-center pt-2'>
                <Link to={`/company-profile?name=${encodeURIComponent(companyData?.company_profile?.company_name || "")}&id=${companyData?.company_profile?.company_id || ""}`} />
                {companyData?.company_profile?.company_logo_url && (
                  <img
                    src={companyData.company_profile.company_logo_url}
                    alt={`${companyData.company_profile.company_name} Logo`}
                    style={{
                      width: '55px',
                      height: '55px',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      marginRight: '12px',
                    }}
                  />
                )}
                <div>
                  <Link
                    style={{ textDecoration: "none" }}
                    to={`/company-profile?name=${encodeURIComponent(companyData?.company_profile?.company_name || "")}&id=${companyData?.company_profile?.company_id || ""}`}
                  >
                    <h3 className='company_management_h3 mb-1'>
                      {companyData?.company_profile?.company_name}
                    </h3>
                  </Link>
                  <h6 className='company_management_p ps-2'>Reviews</h6>
                </div>
              </div>
            </div>

            <div className=''>
              <p className='company_profile_rating_p pt-3 mb-0'>
                Work at {companyData?.company_profile?.company_name}?
              </p>
              <p className='company_profile_rating_p'>
                Rate your manager <span className='text-black fw-bold'>anonymously!</span>
              </p>
            </div>

            <div className='d-flex align-items-center'>
              <Link to="/add-review" className=''>
                <button className='rate_company_profile_btn'>
                  Rate
                  <MdOutlineChevronRight className='ms-1 fs-5' />
                </button>
              </Link>

              <div className='d-flex ms-3'>
                {/* Share ONLY (report removed) */}
                <div
                  onClick={handleCopy}
                  className="icon-btn"
                  style={{ cursor: "pointer" }}
                  title={copied ? "Link copied" : "Copy link"}
                  aria-label={copied ? "Link copied" : "Copy link"}
                >
                  {copied ? (
                    <PiShareFatFill fontSize={25} color="#151515" />
                  ) : (
                    <PiShareFat fontSize={25} color="#151515" />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className='col-lg-6 col-md-6 col-12 pt-lg-0 pt-md-0 pt-3'>
            <Progressbar reviewDistribution={companyData?.company_profile?.review_distribution} />
          </div>
        </div>

        <div className='row pt-lg-5 pt-md-4 pt-3'>
          <div className='col-lg-6 col-md-6 col-12'>
            <h3 className='top_tags_h3'>Top Tags</h3>
            <div className='d-flex flex-wrap gap-2 pt-2'>
              {companyData?.company_profile?.top_positive_tags?.map((tag) => (
                <div
                  key={tag}
                  className="px-3 py-1"
                  style={{
                    backgroundColor: "#EDFDED",
                    cursor: "pointer",
                    borderRadius: "30px",
                    fontSize: "0.85em",
                    color: "#2C2C2C",
                    height: "28px"
                  }}
                >
                  {tag}
                </div>
              ))}
            </div>

            <div className='tags_divider mt-3 mb-2 ms-lg-4 ms-md-3 ms-3' />

            <div className='d-flex flex-wrap gap-2 pt-2'>
              {companyData?.company_profile?.top_negative_tags?.map((tag) => (
                <div
                  key={tag}
                  className="px-3 py-1"
                  style={{
                    backgroundColor: "#FFD0CA",
                    cursor: "pointer",
                    borderRadius: "30px",
                    fontSize: "0.85em",
                    color: "#2C2C2C",
                    height: "28px"
                  }}
                >
                  {tag}
                </div>
              ))}
            </div>
          </div>

          <div className='offset-lg-2 offset-md-2 col-lg-4 col-md-4 col-12'>
            <div>
              <div className='company_rank_box my-lg-5 my-md-4 my-3 d-none'>
                <div className='py-3 px-3'>
                  <h3 className='company_rank_h3 pt-2'>Similar Companies</h3>
                  <div className='px-lg-5 pt-2'>
                    <div id="parent-id">
                      <div className="table-container">
                        <table>
                          <tbody>
                            <tr className="light_grey"><td>Google</td><td>2.9</td></tr>
                            <tr className="light_grey"><td>Meta</td><td>4.8</td></tr>
                            <tr className="light_grey"><td>X</td><td>4.7</td></tr>
                            <tr className="light_grey"><td>Airbnb</td><td>4.7</td></tr>
                            <tr className="light_grey"><td>Oracle</td><td>4.6</td></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className='d-flex justify-content-center pt-3'>
                      <button className='view_more_btn'>View More</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ratings header + Sort */}
        <div className='row'>
          <div className='col-lg-8 col-md-8 col-12'>
            <div className='pt-lg-5 pt-md-4 pt-3'>
              <div className='d-flex justify-content-between align-items-center h-100'>
                <div>
                  <h5 className='ratings_h5_manager_profile mb-0'>
                    {companyData?.company_profile?.reviews?.length} Ratings
                  </h5>
                </div>
                <div>
                  <button
                    type="button"
                    className='btn btn_sort icon-btn'
                    onClick={handleSortClick}
                    title="This feature is coming soon"
                    aria-label="Sort coming soon"
                  >
                    <CiFilter fontWeight={700} color='#6B6B6B' /> Sort
                  </button>
                </div>
              </div>
              <div className='border_bottom_reviews mt-1'></div>

              <AllCompanyReviews companyName={companyData?.company_profile?.company_name} />
            </div>
          </div>
        </div>
      </div>

      <CreateCompanyFooter />
    </div>
  )
}

export default CompanyReviews